if (!customElements.get('mg-photo-reviews')) {
  customElements.define('mg-photo-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const track = this.querySelector('[data-review-track]');
      const previous = this.querySelector('[data-review-prev]');
      const next = this.querySelector('[data-review-next]');
      if (!track || !previous || !next) return;
      const update = () => {
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = direction => track.scrollBy({left: direction * (track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', update, {passive:true});
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(track);
      update();
    }
    disconnectedCallback() { this.resizeObserver?.disconnect(); this.initialized = false; }
  });
}
